module.exports = __webpack_public_path__ + "img/sence-bgyq.fcc0da1b.png";